import axios from '@/utils/newAxios';
import store from '../store.js'


// 获取趋势点集
export function getTrend(params){
    if(  store.state.vtoken  ){    // 需要token
        return axios({
            url:`/gromit/exterior/information/${  params.pid  }/statistics/trends`,
            method:'get',
            params
        });
    }
    else{
        return axios({
            url:`/gromit/thirdparty/miniprogress/statistics/trends`,
            method:'get',
            params
        });
    }

}



// 获取报告列表
export function getPressDataList(params){
    return axios({
        url:`/gromit/thirdparty/miniprogress/stressrecord/pages`,
        method:'get',
        params
    });
}

// 获取报告列表
export function applyNibpReportData(params){
        return axios({
            url:`/gromit/newreport/create`,
            method:'get',
            params
        });
}

// 获取报告详细信息
export function getNibpReportDetailData(params){
        return axios({
            url:`/gromit/newreport/fetch/list/item`,
            method:'get',
            params
        });
}


// 获取报告列表
export function getNibpReportHistoryListData(params){
        return axios({
            url:`/gromit/newreport/fetch/list`,
            method:'get',
            params
        });
}



// 获取趋势点集
export function getNewReportTrend(params){
        return axios({
            url:`/gromit/newreport/statistics/trends`,
            method:'get',
            params
        });
}
// 获取趋势点集
export function getNewReportMonthData(params){
        return axios({
            url:`/gromit/newreport/statistics/trends/detail`,
            method:'get',
            params
        });
}

// 获取趋势点集
export function getMeasureDataDayList(params){
    return axios({
        url:`/gromit/account/${  params.pid  }/mdata/result`,
        method:'get',
        params
    });
}


// 获取趋势点集
export function getNewReportDayData(params){
        return axios({
            url:`/gromit/newreport/statistics/trends/detail/day`,
            method:'get',
            params
        });
}







// 获取统计（只有步数）
export function getStatistics(params){
    if(  store.state.vtoken  ){    // 需要token
        return axios({
            url:`/gromit/exterior/information/record/${  params.pid  }/statistics/amount`,
            method:'get',
            params
        });
    }
    else{
        return axios({
            url:`/gromit/thirdparty/miniprogress/statistics/trends`,
            method:'get',
            params
        });
    }
}

export function getSleepReport(params){
    return axios({
        url:`/gromit/sleep/getSleepStatisticsList`,
        method:'get',
        params
    });
    
}

export function getStepListData(params){
    return axios({
        url:`/gromit/thirdparty/miniprogress/statistics/list`,
        method:'get',
        params
    });
    //gromit/thirdparty/miniprogress/statistics/list?pid=14438&ets=1694188799000&size=20&offset=0
}


export function getSportListData(params){
    return axios({
        url:`/gromit/sports/getSportsList`,
        method:'get',
        params
    });
    
}



export function getSportDetailListData(params){
    return axios({
        url:`/gromit/sports/getSportsDtlList`,
        method:'get',
        params
    });
    
}

export function getSportDetailData(params){
    return axios({
        url:`/gromit/sports/getSportsReportBySportsId`,
        method:'get',
        params
    });
    
}

export function deleteAccount(params){
    return axios({
        url:`/gromit/exterior/user/accountCancellation`,
        method:'post',
        params
    });
    
}

export function loginAccount(params){
    return axios({
        url:`/gromit/exterior/user/login`,
        method:'post',
        params
    });
    
}



// 获取血氧百分比
export function getBOPercentage(params){
    if(  store.state.vtoken  ){    // 需要token
        return axios({
            url:`/gromit/exterior/information/${  params.pid  }/statistics/abnormal`,
            method:'get',
            params
        });
    }
    else{
        return axios({
            url:`/gromit/thirdparty/miniprogress/statistics/abnormal`,
            method:'get',
            params
        });
    }


    


}
